var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExploreArchitecture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blueprint",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.707,
    height: 58.707,
    viewBox: "0 0 58.707 58.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54206",
    "data-name": "Path 54206",
    d: "M3.037,106.519A3.037,3.037,0,0,1,0,103.483V67.045a3.037,3.037,0,0,1,3.037-3.037h49.6v42.511Zm0,0",
    transform: "translate(0 -55.91)",
    fill: "#348fd9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54207",
    "data-name": "Path 54207",
    d: "M0,19.044a3.037,3.037,0,0,1,3.037-3.037H6.073V58.519H3.037A3.037,3.037,0,0,0,0,61.556Zm0,0",
    transform: "translate(0 -13.983)",
    fill: "#4db7e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54208",
    "data-name": "Path 54208",
    d: "M291.453,69.278,286.1,74.636l-1.012,3.037.3.3-3.037,3.037,1.431,1.431,3.037-3.037.3.3,3.036-1.012,9.11-9.11V64.008h-2.53Zm0,0",
    transform: "translate(-246.621 -55.91)",
    fill: "#3086cd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46639",
    "data-name": "Group 46639",
    transform: "translate(9.11 11.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54209",
    "data-name": "Path 54209",
    d: "M138.406,147.1a1.02,1.02,0,0,0-.071-.349c0-.007-.008-.012-.011-.019a1,1,0,0,0-.132-.222l-8.1-10.122a1.011,1.011,0,0,0-.79-.38H113.11a1.012,1.012,0,0,0-.774.367c0,.006-.012.007-.016.012l-8.1,10.122a1.064,1.064,0,0,0-.132.222c0,.007-.008.012-.011.019a1.02,1.02,0,0,0-.071.349c0,.015-.008.027-.008.042v12.146a1.012,1.012,0,0,0,1.012,1.012H137.4a1.012,1.012,0,0,0,1.012-1.012V147.142C138.414,147.128,138.406,147.116,138.406,147.1Zm-9.587-9.068,6.478,8.1h-13.6l-4.319-5.4-2.159-2.7Zm-15.709.607,3.994,4.993,2,2.5H107.119Zm-7.085,9.514H120.2v10.122h-3.037v-7.085a1.012,1.012,0,0,0-1.012-1.012h-6.073a1.012,1.012,0,0,0-1.012,1.012v7.085h-3.037Zm5.061,10.122V152.2h4.049v6.073Zm25.3,0H122.22V148.154h14.17Zm0,0",
    transform: "translate(-99.952 -129.935)",
    fill: "#4db7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54210",
    "data-name": "Path 54210",
    d: "M281.012,254.081h4.049a1.012,1.012,0,0,0,1.012-1.012V249.02a1.012,1.012,0,0,0-1.012-1.012h-4.049A1.012,1.012,0,0,0,280,249.02v4.049A1.012,1.012,0,0,0,281.012,254.081Zm1.012-4.049h2.024v2.024h-2.024Zm0,0",
    transform: "translate(-253.684 -227.765)",
    fill: "#4db7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54211",
    "data-name": "Path 54211",
    d: "M74.024,328.008H72v3.036a1.012,1.012,0,0,0,1.012,1.012h3.037v-2.024H74.024Zm0,0",
    transform: "translate(-72 -297.643)",
    fill: "#4db7e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54212",
    "data-name": "Path 54212",
    d: "M74.024,90.032h2.024V88.008H73.012A1.012,1.012,0,0,0,72,89.02v3.037h2.024Zm0,0",
    transform: "translate(-72 -88.008)",
    fill: "#4db7e5"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54213",
    "data-name": "Path 54213",
    d: "M308.134,145.367l-.56,1.679,2.467,3.083,2.047-.683-3.571-4.462Zm0,0",
    transform: "translate(-268.659 -126.641)",
    fill: "#419bc2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54214",
    "data-name": "Path 54214",
    d: "M281.012,140.514,280,143.551l2.024,2.024,3.036-1.012.506-.506-4.049-4.049Zm0,0",
    transform: "translate(-244.574 -122.294)",
    fill: "#ccccca"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54215",
    "data-name": "Path 54215",
    d: "M292,17.717,309.717,0l4.049,4.049L296.053,21.766Zm0,0",
    transform: "translate(-255.059 -0.004)",
    fill: "#803f37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54216",
    "data-name": "Path 54216",
    d: "M330.344,91.783l1.431-1.431,4.049,4.049-1.432,1.431Zm0,0",
    transform: "translate(-288.548 -78.921)",
    fill: "#ffb531"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54217",
    "data-name": "Path 54217",
    d: "M258.344,173.381l3.036-3.037,1.432,1.432-3.037,3.037Zm0,0",
    transform: "translate(-225.658 -148.792)",
    fill: "#ccccca"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54218",
    "data-name": "Path 54218",
    d: "M216,247.385h31.377V216.008Zm25.3-6.073H231.183L241.3,231.191Zm0,0",
    transform: "translate(-188.671 -188.679)",
    fill: "#ffb531"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54219",
    "data-name": "Path 54219",
    d: "M331.231,312.008l-6.073,6.073v7.085h-7.085L312,331.239h19.231Zm0,0",
    transform: "translate(-272.525 -272.533)",
    fill: "#ffa912"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreArchitecture);
export default __webpack_public_path__ + "static/media/explore-architecture.308bf5897dd8cb21c121b2592f164919.svg";
export { ForwardRef as ReactComponent };